<template>
  <div
    :class="className"
    :style="{ height: height, width: width }"
  />
</template>

<script>
import * as echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import { debounce } from '@/utils/util'
export default {
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      default: () => { return {} }
    },
    title: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler (val) {
        this.setOptions(val)
      }
    }
  },
  mounted () {
    this.initChart()
    if (this.autoResize) {
      this.__resizeHandler = debounce(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 100)
      window.addEventListener('resize', this.__resizeHandler)
      setTimeout(() => {
        if (this.chart) {
          this.chart.resize()
        }
      }, 600)
    }
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    if (this.autoResize) {
      window.removeEventListener('resize', this.__resizeHandler)
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    setOptions ({ electrifiedPotentialAverage, electrifiedPotentialMax, electrifiedPotentialMin, locationDescription, voffAverage, voffMax, voffMin, deviceCode, limitMax1, limitMax2, limitMin1, limitMin2 } = {}) {
      console.log(limitMax1, 'limitMax1limitMax1');
      this.chart.setOption({
        title: {
          text: name + '电位(v)'
        },
        tooltip: {
          trigger: 'axis'
        },
        toolbox: {
          show: true,
          feature: {
            saveAsImage: {}
          }
        },
        legend: {},
        // toolbox: {
        //   show: true,
        //   feature: {
        //     dataZoom: {
        //       yAxisIndex: 'none'
        //     },
        //     dataView: { readOnly: false },
        //     magicType: { type: ['line', 'bar'] },
        //     restore: {},
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: locationDescription
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}V'
          }
        },
        dataZoom: [
          {
            type: 'slider',
            show: true,
            xAxisIndex: [0],
            handleSize: 0, //滑动条的 左右2个滑动条的大小
            height: 10, //组件高度
            left: 550, //左边的距离
            right: 540, //右边的距离
            bottom: 506, //右边的距离
            handleColor: '#ddd' //h滑动图标的颜色
          },
          {
            type: 'inside',
            start: 0,
            end: 50,
            textStyle: {
              color: '#fff'
            }
          },
          {
            show: true,
            type: 'slider',
            // y: '94%',
            bottom: '0',
            start: 0,
            end: 50,
            textStyle: {
              color: '#fff'
            }
          }
        ],
        series: [
          // {
          //   name: '通电电位',
          //   type: 'line',
          //   data: electrifiedPotentialAverage,
          //   markLine: {
          //     silent: true,
          //     lineStyle: {
          //       normal: {
          //         color: '#fdd2d2' // 这儿设置安全基线颜色
          //       }
          //     },
          //     data: [
          //       {
          //         yAxis: limitMin2
          //       },
          //       {
          //         yAxis: limitMax2
          //       }
          //     ],
          //     label: {
          //       normal: {
          //         formatter: '2' // 这儿设置安全基线
          //       }
          //     }
          //   }
          // },
          // {
          //   name: '断电电位',
          //   type: 'line',
          //   data: y2,
          //   // markPoint: {
          //   //   data: [
          //   //     { type: 'max', name: '最大值' },
          //   //     { type: 'min', name: '最小值' }
          //   //   ]
          //   // },
          //   markLine: {
          //     silent: true,
          //     lineStyle: {
          //       normal: {
          //         color: '#fdd2d2' // 这儿设置安全基线颜色
          //       }
          //     },
          //     data: [
          //       {
          //         yAxis: limitMin1
          //       },
          //       {
          //         yAxis: limitMin2
          //       }
          //     ],
          //     label: {
          //       normal: {
          //         formatter: '1' // 这儿设置安全基线
          //       }
          //     }
          //   }
          // },
          {
            name: '通电平均值',
            type: 'line',
            data: electrifiedPotentialAverage,
            markLine: {
              silent: true,
              lineStyle: {
                normal: {
                  type: 'dashed',
                  color: '#fdd2d2' // 这儿设置安全基线颜色
                }
              },
              data: [
                {
                  yAxis: -0.85
                },
                {
                  yAxis: -1.2
                }
              ],
              label: {
                normal: {
                  formatter: '' // 这儿设置安全基线
                }
              }
            }
          },
          {
            name: '通电最大值',
            type: 'line',
            data: electrifiedPotentialMax,
          },
          {
            name: '通电最小值',
            type: 'line',
            data: electrifiedPotentialMin,
          },
          {
            name: '断电平均值',
            type: 'line',
            data: voffAverage,
            // markLine: {
            //   silent: true,
            //   lineStyle: {
            //     normal: {
            //       type: 'dashed',
            //       color: '#fdd2d2' // 这儿设置安全基线颜色
            //     }
            //   },
            //   data: [
            //     {
            //       yAxis: limitMin1
            //     },
            //     {
            //       yAxis: limitMin2
            //     }
            //   ],
            //   label: {
            //     normal: {
            //       formatter: '' // 这儿设置安全基线
            //     }
            //   }
            // }
          },
          {
            name: '断电最大值',
            type: 'line',
            data: voffMax,
          },
          {
            name: '断电最小值',
            type: 'line',
            data: voffMin,
          },
        ]
      })
    },
    initChart () {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
      this.chart.on('click', params => {
        // 控制台输出点击的数据的信息
        console.log(params, 'paramsparamsparams===');
        this.$emit('chanegDetail', params)
        // 在这里可以编写点击事件后需要执行的代码
      });
    }
  }
}
</script>
